/* eslint-disable no-unused-vars */
import { resetPasswordAction } from '@store/StaticStore/authSlice'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Formik } from 'formik'

import { useQuery } from '@utils/useQuery'
import { error } from '@services/toast-service'
import { validateEmail, validatePassword } from '@utils/validator'

type Props = {}

const ResetPassword: React.FC<Props> = () => {
  const { isSubmitingResetPwd } = useSelector(state => state.auth)
  const dispatch = useDispatch()
  const query = useQuery()
  const history = useHistory()

  const token = query.get('token')
  const email = query.get('email')

  useEffect(() => {
    if (!token) {
      error('Tokenが正しくない。')
      history.push('/forgot-password')
    }
  }, [history, token])

  return (
    <div className="registration-form">
      <div className="login-box">
        <div className="form-icon">
          <img src="/assets/img/GMTS_horizontal_logo.png" alt="" />
        </div>
        <Formik
          initialValues={{ password: '', confirmPassword: '', email: email || '', token } as TAuthAPI.Body.ResetPassword}
          validate={values => {
            const errors: { [x in keyof TAuthAPI.Body.ResetPassword]?: string } = {}
            if (!values.email) {
              errors.email = 'メールアドレスが必須です。'
            } else if (!validateEmail(values.email)) {
              errors.email = 'メールアドレスを正しく入力してください'
            }

            if (!values.password) {
              errors.password = 'パスワードが必須です。'
            } else if (!validatePassword(values.password)) {
              errors.password = 'パスワードは半角6~12文字英大文字・記号・小文字・数字それぞれ１文字以上含む必要があります。'
            }

            if (values.password && values.confirmPassword && values.password !== values.confirmPassword) {
              errors.confirmPassword = 'パスワードを再入力してください。'
            }

            return errors
          }}
          onSubmit={values => {
            dispatch(resetPasswordAction(values))
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-lock" /></span>
                  </div>
                  <input
                    value={values.password}
                    onChange={handleChange}
                    name="password"
                    className="form-control"
                    placeholder="ユーザー名"
                    type="password"
                  />
                </div>
                {errors.password && touched.password && errors.password}
              </div>
              <div className="mb-2">
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-lock" /></span>
                  </div>
                  <input
                    value={values.confirmPassword}
                    onChange={handleChange}
                    name="confirmPassword"
                    className="form-control"
                    placeholder="パスワードを入力してください。"
                    type="password"
                  />
                </div>
                {errors.confirmPassword && errors.confirmPassword}
              </div>
              <div className="mb-2">
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-envelope" /></span>
                  </div>
                  <input
                    value={values.email}
                    onChange={handleChange}
                    name="email"
                    className="form-control"
                    placeholder="Eメール"
                    type="email"
                  />
                </div>
                {errors.email && touched.email && errors.email}
              </div>
              <div className="form-group text-center">
                <button disabled={isSubmitingResetPwd} type="submit" className="btn btn-block create-account">
                  {isSubmitingResetPwd ? 'パスワードのリセット（申請中）' : 'パスワードのリセット'}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default ResetPassword
